module.exports = __webpack_public_path__ + "img/step-peo.a58e0a32.png";